"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextSizeSelectDialog;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TextSizeSelectDialog(props) {
  var textSizes = ["Regular", "Medium", "Large"];
  var onClose = props.onClose,
      selectedValue = props.selectedValue,
      open = props.open;

  var handleClose = function handleClose() {
    onClose(selectedValue);
  };

  var handleListItemClick = function handleListItemClick(textSize) {
    onClose(textSize);
  };

  return /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    onClose: handleClose,
    "aria-labelledby": "simple-dialog-title",
    open: open
  }, /*#__PURE__*/_react.default.createElement(_material.DialogTitle, {
    id: "simple-dialog-title",
    tabIndex: "0"
  }, "Select text size"), /*#__PURE__*/_react.default.createElement(_material.List, null, textSizes.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      button: true,
      onClick: function onClick() {
        return handleListItemClick(option);
      },
      key: option
    }, /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      primary: option
    }));
  })));
}

TextSizeSelectDialog.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  selectedValue: _propTypes.default.string.isRequired
};